"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Box2 = _interopRequireDefault(require("@mui/material/Box"));
var _Typography2 = _interopRequireDefault(require("@mui/material/Typography"));
var _Skeleton2 = _interopRequireDefault(require("@mui/material/Skeleton"));
var _Button3 = _interopRequireDefault(require("@mui/material/Button"));
var _react = _interopRequireDefault(require("react"));
var _hooks = require("../../../hooks");
var _geogroupAvatar = require("../../geogroup-avatar");
var _sponsorBadge = require("../../sponsor-badge");
var _medals = require("../medals");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function LeaderboardCompanyItem({
  Button: _Button,
  blurred,
  ownGeogroup,
  challengeType,
  item,
  prevItemRank,
  enableParticipants,
  onOwnCompanyClick
}) {
  const {
    getProgressValueWithUnit
  } = (0, _hooks.useChallenge)();
  const {
    formatNumber
  } = (0, _hooks.useUnits)();
  const Button = _Button || _Button3.default;
  const medal = item && _medals.medals[item.rank - 1] || null;
  return /*#__PURE__*/_react.default.createElement(_Box2.default, _extends({
    alignItems: "center",
    display: "flex",
    gap: 1,
    paddingX: 2,
    paddingY: 1,
    sx: {
      justifyContent: 'flex-start',
      textAlign: 'left',
      textTransform: 'initial',
      color: 'initial',
      ...(blurred ? {
        filter: 'blur(0.25rem)'
      } : {})
    }
  }, onOwnCompanyClick && item && ownGeogroup && ownGeogroup.id === item.id ? {
    component: Button,
    onClick: onOwnCompanyClick
  } : {}), /*#__PURE__*/_react.default.createElement(_Box2.default, {
    display: "flex",
    flexShrink: 0,
    height: 24,
    justifyContent: "center",
    width: 30
  }, !item ? /*#__PURE__*/_react.default.createElement(_Skeleton2.default, {
    variant: "text",
    width: 24
  }) : item.rank === prevItemRank ? /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    align: "center",
    fontWeight: 700
  }, "-") : medal ? /*#__PURE__*/_react.default.createElement("img", {
    src: medal.icon,
    width: 24
  }) : /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    align: "center",
    fontWeight: 700
  }, Math.max(item.rank, item.leaderboardIndex))), /*#__PURE__*/_react.default.createElement(_geogroupAvatar.GeogroupAvatar, {
    geogroup: item ? {
      title: item.parentTitle || item.title,
      photo: item.parentPhoto || item.photo
    } : undefined,
    size: 48
  }), /*#__PURE__*/_react.default.createElement(_Box2.default, {
    alignItems: "center",
    display: "flex",
    flexGrow: 1,
    gap: 2
  }, /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    fontWeight: 700,
    variant: "body2"
  }, item ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, item.parentTitle ? `${item.parentTitle} - ` : '', item.title) : /*#__PURE__*/_react.default.createElement(_Skeleton2.default, {
    variant: "text",
    width: 100
  })), item?.certified && /*#__PURE__*/_react.default.createElement(_sponsorBadge.SponsorBadge, {
    size: "small"
  })), enableParticipants && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Box2.default, {
    flexShrink: 0,
    width: 100
  }, /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    noWrap: true,
    align: "center",
    variant: "body2"
  }, item ? formatNumber(item.activeParticipantsCount) : /*#__PURE__*/_react.default.createElement(_Skeleton2.default, {
    variant: "text",
    width: "100%"
  }))), /*#__PURE__*/_react.default.createElement(_Box2.default, {
    flexShrink: 0,
    width: 100
  }, /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    noWrap: true,
    align: "center",
    variant: "body2"
  }, item ? getProgressValueWithUnit(challengeType || 'bttf', item.activeParticipantsCount ? item.progressValue / item.activeParticipantsCount : 0) : /*#__PURE__*/_react.default.createElement(_Skeleton2.default, {
    variant: "text",
    width: "100%"
  })))), /*#__PURE__*/_react.default.createElement(_Box2.default, {
    flexShrink: 0,
    width: 80
  }, /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    noWrap: true,
    align: "right",
    variant: "body2"
  }, item ? getProgressValueWithUnit(challengeType || 'bttf', item.progressValue) : /*#__PURE__*/_react.default.createElement(_Skeleton2.default, {
    variant: "text",
    width: "100%"
  }))));
}
var _default = exports.default = LeaderboardCompanyItem;